<template>
  <b-modal
    ref="modal"
    :cancel-variant="data.cancelVariant || undefined"
    :header-bg-variant="data.headerBgVariant || undefined"
    :footer-bg-variant="data.footerBgVariant || undefined"
    :header-text-variant="data.headerTextVariant  || undefined"
    size="xl"
    dialog-class="modal-full modal-search-in-header"
    content-class="h-100"
    body-class="h-100"
    :title="_trans('Divider')"
    :centered="data.centered || false"
    :scrollable="false"
    :no-close-on-backdrop="data.noCloseOnBackdrop || false"
    :no-close-on-esc="data.noCloseOnEsc || false"
    :hide-header-close="data.hideHeaderClose || false"
    @close="dismiss()"
    @hide="hide"
    @hidden="onClose"
    @shown="onShow"
  >
    <template v-slot:modal-header-close>
      <b-button
        size="sm"
        variant="primary"
        class="ni ni-close"
        @click="close()"
      >
      </b-button>
    </template>
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-3 col-sm-12 left-panel">
          <b-alert
            :show="accessoriesInserted"
            variant="primary"
          >
            <i
              style="font-size: 30px;"
              class="ni ni-info"
            ></i>
            <br>
            <span v-text="_trans('Pay attention, accessoriesSystem already included in the structure...')"></span>
          </b-alert>
          <div
            v-if="false"
            class="row mb-2"
          >
            <div class="col">
              <textarea
                v-model="treeString"
                class="form-control"
                rows="5"
              ></textarea>
              <div class="row mt-2">
                <div class="col-xl-6 col-sm-12">
                  <button
                    type="submit"
                    class="btn btn-block d-flex align-items-center"
                    :title="_trans('Serialize Tree')"
                    @click="serializeTree()"
                  >
                    <span
                      class="text-truncate"
                      v-text="_trans('Serialize Tree')"
                    ></span>
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="submit"
                    class="btn btn-block d-flex align-items-center"
                    :title="_trans('Deserialize Tree')"
                    @click="deserializeTree()"
                  >
                    <span
                      class="text-truncate"
                      v-text="_trans('Deserialize Tree')"
                    ></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!--
                              <div class="row">
                                  <div class="col mb-2">
                                      <button type="submit" class="btn btn-block d-flex align-items-center" @click="caddivider.applyDividerRule(this.getRule())">
                                          <span class="text-truncate" v-html="_trans('Load divider')"></span>
                                      </button>
                                  </div>
                              </div>
          -->
          <div class="row no-gutters mb-2">
            <div class="col m-1">
              <div
                class="m-auto"
                style="max-width: 190px;"
              >
                <button
                  id="tooltip-divider-create"
                  class="btn square align-items-center"
                  type="submit"
                  v-bind:class="{ active: buttonActive === 'divider-create' }"
                  @click="caddivider.goToCreateDivisionsPhase(); changeButtonActive('divider-create')"
                >
                  <span class="di di-divider-create"></span>
                </button>
                <b-tooltip target="tooltip-divider-create" triggers="hover" placement="bottom">
                  <span class="text-truncate" v-html="_trans('Create Divisions')"></span>
                </b-tooltip>
                <button
                  v-bind:class="{ active: buttonActive === 'divider-move' }"
                  v-on:click="changeButtonActive('divider-move')"
                  type="submit"
                  class="btn square align-items-center"
                  @click="caddivider.goToMoveDivisionPhase()"
                  id="tooltip-divider-move"
                >
                  <span class="di di-divider-move"></span>
                </button>
                <b-tooltip target="tooltip-divider-move" triggers="hover" placement="bottom">
                  <span class="text-truncate" v-html="_trans('Move Divisions')"></span>
                </b-tooltip>
                <button
                  v-bind:class="{ active: buttonActive === 'divider-job' }"
                  v-on:click="changeButtonActive('divider-job')"
                  type="submit"
                  class="btn square align-items-center"
                  @click="caddivider.goToMansardsPhase()"
                  id="tooltip-divider-job"
                >
                  <span class="di di-job"></span>
                </button>
                <b-tooltip target="tooltip-divider-job" triggers="hover" placement="bottom">
                  <span class="text-truncate" v-html="_trans('Mansards')"></span>
                </b-tooltip>
              </div>
            </div>
          </div>
          <div class="row  mb-2">
            <div class="col">
            </div>
          </div>
          <!--
                              <div class="row">
                                  <div class="col mb-2">
                                      <button type="submit" class="btn btn-block d-flex align-items-center" @click="caddivider.goToDrawDividerPhase()">
                                          <span class="text-truncate" v-html="_trans('Draw Divider')"></span>
                                      </button>
                                  </div>
                              </div>
          -->
          <div class="row  mb-3">
            <div class="col">
            </div>
          </div>
          <!--
                              <div class="row">
                                  <div class="col mb-2">
                                      <button type="submit" class="btn btn-block d-flex align-items-center" @click="caddivider.goToMultipleAreaSelectionFront()">
                                          <span class="text-truncate" v-html="_trans('Multiple Area Selection Front')"></span>
                                      </button>
                                  </div>
                              </div>

                              <div class="row">
                                  <div class="col mb-2">
                                      <button type="submit" class="btn btn-block d-flex align-items-center" @click="caddivider.goToMultipleAreaSelectionBack()">
                                          <span class="text-truncate" v-html="_trans('Multiple Area Selection Back')"></span>
                                      </button>
                                  </div>
                              </div>
                              <div class="row">
                                  <div class="col mb-2">
                                      <button type="submit" class="btn btn-block d-flex align-items-center" @click="caddivider.goToMultipleSelections()">
                                          <span class="text-truncate" v-html="_trans('Multiple Selections')"></span>
                                      </button>
                                  </div>
                              </div>
                              <rule-article
                                      v-if="currentRule"
                                      :data="currentRule"
                                      :catalog="data.catalog"
                                      :divider-data="{ layer: this.layer, layid: this.layid}"
                                      :show-measures="false"
                                      :show-divider="false"
                                      @update="updatedRuleArticle($event)"
                              ></rule-article>
          -->
          <div v-if="areaSelected">
            <hr>
            <div class="row mt-4 mb-3">
              <div class="col">
                <span class="text-truncate font-weight-bold h5" v-html="_trans('Split Area')"></span>
              </div>
            </div>
            <div class="row">
              <div class="col mb-2">
                <input v-model="areaHorizontalSplit" type="number"/>
              </div>
              <div class="col mb-3">
                <input v-model="areaVerticalSplit" type="number"/>
              </div>
              <div class="col mb-3">
                <button type="submit" class="btn btn-start btn-block" v-html="_trans('Split')" @click="splitArea()"></button>
              </div>
            </div>
          </div>
          <div v-if="divisionSelected">
            <hr>
            <div class="row mt-4 mb-3">
              <div class="col">
                <span class="text-truncate font-weight-bold h5" v-html="_trans('Edit division')"></span>
              </div>
            </div>
            <div class="row">
              <div class="col d-flex flex-row">
                <span class="font-weight-bold" v-html="_trans('Type:')"></span><span class="text-truncate ml-2">{{ divType }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col d-flex flex-row">
                <span class="font-weight-bold" v-html="_trans('Tot:')"></span><span class="text-truncate ml-2">{{ totalQuote }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col d-flex flex-row">
                <span class="font-weight-bold" v-html="_trans('Thickness:')"></span><span class="text-truncate ml-2">{{ thickness }}</span>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col mb-2">
                <label v-html="_trans('Left distance:')"></label>
                <input class="text-truncate" v-model="distanceIntLeft" @change="updateEditType('LEFT')" type="number"/>
              </div>
              <div class="col mb-2">
                <label v-html="_trans('Right distance:')"></label>
                <input class="text-truncate" v-model="distanceIntRight" @change="updateEditType('RIGHT')" type="number"/>
              </div>
              <div class="col">
                <label v-html="_trans('Move in Percentage:')"></label>
                <input class="text-truncate" v-model="percentageHundred" @change="updateEditType('PERC')" type="number"/>
              </div>
              <div class="col mt-3">
                <button type="submit" class="btn btn-block btn-start" v-html="_trans('Move')" @click="caddivider.applyQuotes(distanceIntLeft, distanceIntRight, percentageHundred, editType, thickness)"></button>
                <button type="submit" class="btn btn-block btn-start" v-html="_trans('Delete')" @click="caddivider.deleteSelectedDivision()"></button>
              </div>
            </div>
          </div>

        </div>

        <div class="col-xl-9 col-sm-12">
          <d-caddivider ref="caddivider" :rule="currentRule" :catalog="data.catalog" @callbackUpdateSelected="updateSelected" @callbackRuleUpdated="updatedRuleDivider" style="height: calc(100vh - 230px);"></d-caddivider>
        </div>
      </div>
    </div>
    <div slot="modal-footer">
      <b-button variant="primary" class="btn text-center" @click="dismiss()" v-html="_trans('Apply')"></b-button>
    </div>
  </b-modal>
</template>
<script>
    import {customImport} from "@/utils";
    import modal from "@dialogs/modal.vue";

    export default {
        mixins: [modal],
        components: {
            variant: () => customImport("comp/variant.vue"),
            ruleArticle: () => customImport("comp/ruleArticle.vue")
        },
        data() {
            return {
                caddivider: {},
                treeString: "vuoto",
                areaHorizontalSplit: 2,
                areaVerticalSplit: 2,
                distanceIntLeft: 0,
                distanceIntRight: 0,
                percentageHundred: 0,
                areaSelected: false,
                divisionSelected: false,
                divType: "",
                totalQuote: 0,
                thickness: 0,
                editType: "",
                layid: -1,
                layer: -1,
                buttonActive: null,
                currentRule: null
            };
        },
        computed: {
            accessoriesInserted() {
                // ISACC_1000
                if (this.currentRule && this.currentRule.reg) {
                    let arrIsacc = this.currentRule.reg
                        .split("\t")
                        .filter(part => {
                            return !!part;
                        })
                        .filter(itm => {
                            return itm.toUpperCase().indexOf("ISACC") === 0;
                        });
                    let arrVal = [];
                    arrIsacc.forEach(itm => {
                        let k = itm.ex("=", 1);
                        let v = itm.ex("=", 2);
                        arrVal.push(v);
                    });
                    let check = arrVal.filter(itm => {
                        return itm === "1";
                    });
                    return check.length > 0;
                } else {
                    return false;
                }
            }
        },
        watch: {},
        mounted() {
            this.caddivider = this.$refs.caddivider;
        },
        updated() {
            this.caddivider = this.$refs.caddivider;
        },
        methods: {
            changeButtonActive(btn) {
                switch (btn) {
                    case "divider-create":
                        if (this.buttonActive === "divider-create") {
                            this.buttonActive = null
                        } else {
                            this.buttonActive = "divider-create"
                        }
                        break;
                    case "divider-move":
                        if (this.buttonActive === "divider-move") {
                            this.buttonActive = null
                        } else {
                            this.buttonActive = "divider-move"
                        }
                        break;
                    case "divider-job":
                        if (this.buttonActive === "divider-job") {
                            this.buttonActive = null
                        } else {
                            this.buttonActive = "divider-job"
                        }
                        break;
                }
            },
            dismiss() {
                this.response = this.currentRule;
                this.close(1);
            },
            onShow() {
                this.currentRule = this.data.rule.clone();
                this.caddivider = this.$refs.caddivider;
                this.caddivider.applyDividerRule(this.currentRule);
                this.areaSelected = this.caddivider.areaSelected;
            },
            serializeTree() {
                this.treeString = this.caddivider.serializeTree();
            },
            deserializeTree() {
                this.caddivider.deserializeTree(String(this.treeString));
            },
            splitArea() {
                let row = Number(this.areaHorizontalSplit);
                let col = Number(this.areaVerticalSplit);
                this.caddivider.divideArea(row, col);
            },
            updateSelected(data) {
                let area = data.area;
                let divisionSelected = data.divisionSelected;
                this.areaSelected = area;
                this.divisionSelected = divisionSelected;
                this.distanceIntLeft = data.distanceIntLeft;
                this.distanceIntRight = data.distanceIntRight;
                this.percentageHundred = data.percentageHundred;
                this.divType = data.divType;
                this.editType = data.divType;
                this.thickness = data.thickness;
                this.totalQuote = data.distanceIntTotal;
                this.layid = data.layerID;
                this.layer = data.layerType;
            },
            updateEditType(editType) {
                this.editType = editType;
            },
            updatedRuleArticle(rule) {
                //this.currentRow.rule = rule;
                //this.currentRow.reg = rule.reg;
                this.currentRule = rule;
                this.caddivider.applyDividerRule(rule);
            },
            updatedRuleDivider(rule) {
                //this.currentRow.rule = rule;
                //this.currentRow.reg = rule.reg;
                this.currentRule = rule;
            }
        }
    };
</script>
<style scoped lang="scss">
  /*.modal-full {
                                      min-width: 100%;
                                      margin: 0;

                                      .modal-content {
                                          min-height: 100vh;
                                      }
                                  }

                                  .modal-content {
                                      max-height: 100%;

                                      .modal-header {
                                          !*display: block;*!
                                          !*background-color: #e4e4e4;*!
                                      }

                                      .modal-body {
                                          max-height: 100%;
                                          min-height: 100%;
                                          overflow: auto;
                                          background-color: #fff;

                                          .sidebar {
                                          }

                                          .content {
                                              min-height: 100%;
                                              overflow-y: auto;

                                              .obsolete {
                                                  text-decoration: line-through;
                                              }
                                          }
                                      }

                                      .modal-footer{
                                        background: #fff;
                                      }
                                  }*/

  button.square {
    padding: 0.75rem 0;
    cursor: pointer;
  }

  .di-divider-create:before, .di-divider-move:before, .di-job:before {
    font-size: 2rem;
    border: 2px solid #c2c2c2;
    padding: 10px;
  }

  input[type="number"] {
    border: 2px solid #c2c2c2;
    padding: 3px 10px;
    width: -webkit-fill-available;
  }

  .left-panel {
    border: 2px solid #ebebeb;
    padding: 20px 20px;
    background-color: $light;
  }

  label {
    display: inline-block;
    margin-bottom: 0;
    font-size: 11px;
  }

  .active {
    span:before {
      border: 2px solid $primary;
    }
  }
  .col-3 {
    max-width: 20%;
  }
</style>



// WEBPACK FOOTER //
// src/app/dialogs/modalDivider.vue